const stripRolePrefix = (role) =>
  String(role || "")
    .trim()
    .replace(/^ROLE_/i, "")
    .toUpperCase();

const roleMatches = (roles, name) =>
  (Array.isArray(roles) ? roles : []).some((role) => {
    const normalized = stripRolePrefix(role);
    return normalized === name || normalized.split(/[^A-Z0-9]+/).includes(name);
  });

/** Realm roles plus client roles from a Keycloak access token. */
export const collectKeycloakRoles = (tokenParsed = {}) => {
  const realmRoles = tokenParsed?.realm_access?.roles || [];
  const clientRoles = Object.values(tokenParsed?.resource_access || {}).flatMap(
    (access) => access?.roles || [],
  );
  return [...new Set([...realmRoles, ...clientRoles])];
};

export const isNctcogUser = (roles) => roleMatches(roles, "NCTCOG");

export const isRbfsUser = (roles) =>
  roleMatches(roles, "RBFS") || roleMatches(roles, "RDFS");

/** Fixed project name shown for a logged-in organization role. */
export const getProjectNameForRoles = (roles) => {
  if (isNctcogUser(roles)) return "NCTCOG";
  if (isRbfsUser(roles)) return "RBFS";
  return "";
};
